import get from 'lodash-es/get'
import isNaN from 'lodash-es/isNaN'
import isNil from 'lodash-es/isNil'
import React from 'react'
import { commaNumber } from '#/utils/number'
import { Section } from '../MLSDetails/SubView'
import type { ItemProps, SubItemProps } from '../MLSDetails/types'
import PublicRecordsData from './PublicRecordsData'
import type { PublicRecordsSubViewProps } from './types'

export const Item: React.FC<ItemProps> = ({ children }) => {
  if (isNil(children) || isNaN(children)) return null

  const hasChild = (
    (Array.isArray(children) ? children : [children]) as []
  ).reduce((acc, cur) => get(cur, 'props.children') || acc, false)
  if (!hasChild) return null

  return (
    <div className='p-3 pt-0 text-sm'>
      <div className='mt-1 grid grid-cols-1 gap-x-1 gap-y-4 text-xs'>
        {children}
      </div>
    </div>
  )
}

export const SubItem: React.FC<SubItemProps> = ({
  comma,
  title,
  prefix,
  children
}) => {
  // eslint-disable-next-line eqeqeq
  if (isNil(children) || isNaN(children) || children == 0) return null

  const formatValue = (value: any) => {
    if (typeof value === 'boolean') return String(value)
    let ret = value
    ret = comma ? commaNumber(value) : value

    return ret
  }

  return (
    <div className='flex'>
      <span className='inline-block w-32 shrink-0 grow-0 text-gray-400'>
        {title}
        :
      </span>
      {prefix}
      <div>
        {Array.isArray(children) ? children.join(', ') : formatValue(children)}
      </div>
    </div>
  )
}

const PublicRecordsSubView: React.FC<PublicRecordsSubViewProps> = ({
  authenticated,
  publicRecord
}) => {
  if (!publicRecord) return null

  return (
    <div className='space-y-3'>
      <PublicRecordsData
        Item={Item}
        Section={Section}
        SubItem={SubItem}
        authenticated={authenticated}
        publicRecord={publicRecord}
      />
    </div>
  )
}

export default PublicRecordsSubView
